var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.307,
    height: 78.307,
    viewBox: "0 0 78.307 78.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-circle-left",
    "data-name": "Icon awesome-arrow-circle-left",
    d: "M39.154,78.307A39.154,39.154,0,1,1,78.307,39.154,39.147,39.147,0,0,1,39.154,78.307Zm4.563-22.671L31.8,44.206H60.625a3.78,3.78,0,0,0,3.789-3.789V37.891A3.78,3.78,0,0,0,60.625,34.1H31.8l11.92-11.43a3.793,3.793,0,0,0,.063-5.415l-1.737-1.721a3.773,3.773,0,0,0-5.352,0L15.74,36.47a3.773,3.773,0,0,0,0,5.352l20.95,20.95a3.773,3.773,0,0,0,5.352,0l1.737-1.721A3.793,3.793,0,0,0,43.716,55.636Z",
    transform: "translate(78.307 78.307) rotate(180)",
    fill: "#475e6a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.d7b74c651089c29730fe733f51788ff9.svg";
export { ForwardRef as ReactComponent };